import { Injectable } from '@angular/core';
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import { FirebaseApp } from 'firebase/app';

@Injectable({
  providedIn: 'root',
})
export class PlatformIdentificationService {
  identifyPlatform(app: FirebaseApp): void {
    const analytics = getAnalytics(app);

    setUserProperties(analytics, {
      app_platform: 'web',
      device_category: 'web',
      platform_type: 'web',
    });

    logEvent(analytics, 'platform_identified', {
      platform: 'web',
      device_type: 'web',
      user_agent: navigator.userAgent,
    });

    logEvent(analytics, 'browser_info', {
      user_agent: navigator.userAgent,
      language: navigator.language,
    });
  }

  getPlatformInfo(): {
    platform: string;
    deviceType: string;
    userAgent: string;
  } {
    return {
      platform: 'web',
      deviceType: 'web',
      userAgent: navigator.userAgent,
    };
  }
}
